<template>
  <DropdownModule
    v-if="share"
    :text="isMobile || !showSidebar ? '' : 'share'"
    icon="icon-share text-14"
    :background="isDarkMode ? 'bg-sidebar' : 'bg-white'"
    append-to-body
    position-menu="right"
    class="flex"
    button-classes="px-10 py-8"
  >
    <div class="p-20 rounded-10 text-15 text-app-color" @click.stop>
      <p class="font-semibold text-17">Share</p>
      <ToggleModule :value="share.isActive" color="bg-main-color" label="Share page" class="mt-10" @input="toggleShare" />

      <div v-if="share.isActive" class="mt-10">
        <RadioModule input-value="read" label="Read only" :value="share.mode" @input="toggleEdit" />
        <RadioModule input-value="write" label="Allow editing" :value="share.mode" class="mt-5" @input="toggleEdit" />

        <p class="font-semibold mt-15">Share this link:</p>

        <div class="mt-5 flex items-center">
          <input
            type="text"
            :readonly="true"
            :value="link"
            class="w-full text-13 rounded-l-4 h-30 p-5 outline-none"
            :class="isDarkMode ? 'bg-primary' : 'bg-grey-150'"
          >

          <div
            class="min-w-75 border-2 flex items-center rounded-r-4 flex-shrink-0 px-10 text-13 h-30 cursor-pointer text-white bg-link-color
              hover:text-link-color hover:bg-transparent border-transparent hover:border-link-color transition-all duration-300"
            @click="copyLink"
          >
            {{ btnText }}
          </div>
        </div>
      </div>
    </div>
  </DropdownModule>
</template>

<script>
import { defineComponent, ref, watch, computed } from 'vue'
import { useStore } from 'vuex'

import DropdownModule from '@/components/shared/form-controls/DropdownModule'
import ToggleModule from '@/components/shared/form-controls/ToggleModule'
import RadioModule from '@/components/shared/form-controls/RadioModule'
import { projectService } from '@/services'
import { useRoute } from 'vue-router'

export default defineComponent({
  components: { DropdownModule, ToggleModule, RadioModule },

  props: {
    project: {
      type: Object,
      default: () => {}
    }
  },

  setup (props) {
    const route = useRoute()
    const { state, getters, dispatch, commit } = useStore()

    const btnText = ref('copy link')

    const isMobile = computed(() => getters.isMobile)
    const isDarkMode = computed(() => getters.isDarkMode)
    const showSidebar = computed(() => state.settings.showSidebar)
    const share = computed(() => state.project.share)
    const user = computed(() => state.profile.user)
    const link = computed(() => {
      const userValue = user.value.profile.userName || `${user.value.profile.firstName}${user.value.profile.lastName}`

      return `${location.origin}/${userValue}/share/${share.value.id}`.toLowerCase()
    })

    watch(() => route.query, to => {
      if (to.page) {
        dispatch('getShare', to.page)
          .then((data) => {
            if (!data.id) {
              projectService.postShare({
                isActive: false,
                mode: 'read',
                projectId: to.page
              }).then(({ data }) => commit('setShare', data))
            }
          })
      }
    })

    if (!share.value?.id) {
      dispatch('getShare', props.project.id)
        .then((data) => {
          if (!data.id) {
            return projectService.postShare({
              isActive: false,
              mode: 'read',
              projectId: props.project.id
            }).then(({ data }) => commit('setShare', data))
          }
        })
    }

    function toggleShare (value) {
      projectService.postShare({
        isActive: value,
        mode: share.value.mode,
        projectId: props.project.id
      }).then(({ data }) => commit('setShare', data))
    }

    function toggleEdit (value) {
      projectService.postShare({
        isActive: share.value.isActive,
        mode: value,
        projectId: props.project.id
      }).then(({ data }) => commit('setShare', data))
    }

    function copyLink () {
      const el = document.createElement('input')
      el.value = link.value
      document.body.appendChild(el)
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)

      btnText.value = 'copied!'
      setTimeout(() => {
        btnText.value = 'copy link'
      }, 3000)
    }

    return {
      // ref
      btnText,
      // computed
      isMobile,
      isDarkMode,
      showSidebar,
      share,
      user,
      link,
      // function
      toggleShare,
      toggleEdit,
      copyLink
    }
  }
})
</script>
